import React from "react";
import Select from "react-select";

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: "3rem",
        borderColor: state.isFocused ? "#059669" : "#d1d5db",
        boxShadow: state.isFocused ? "0 0 0 1px #059669" : "none",
        "&:hover": { borderColor: "#047857" },
    }),
    menu: (base) => ({ ...base, zIndex: 30 }),
};

export default function FormSelectField({
    label,
    htmlFor,
    required = false,
    options = [],
    value,
    onChange,
    placeholder,
    isClearable = true,
    isSearchable = true,
    isDisabled = false,
}) {
    return (
        <div>
            <label htmlFor={htmlFor} className="block text-md font-medium text-gray-700 mb-2">
                {label}
                {required && <span className="text-red-500"> *</span>}
            </label>
            <Select
                inputId={htmlFor}
                options={options}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                isClearable={isClearable}
                isSearchable={isSearchable}
                isDisabled={isDisabled}
                styles={selectStyles}
                classNamePrefix="product-select"
            />
        </div>
    );
}
